import { useGetCurrentUser } from '@/api/generated';

const CURRENT_USER_IS_MIDOT_STALE_TIME_MS = 15 * 60 * 1000;

export const useIsMidotUser = (): { isMidotUser: boolean; isLoading: boolean } => {
  const { data: currentUser, isLoading: isLoadingCurrentUser } = useGetCurrentUser({
    query: {
      staleTime: CURRENT_USER_IS_MIDOT_STALE_TIME_MS
    }
  });

  return { isMidotUser: currentUser?.isMidotEmployee ?? false, isLoading: isLoadingCurrentUser };
};
